import _, { reject } from 'lodash';
import ah from '../utils/ajax-helper'; // 資料蒐集系統服務監控

export var getSystemDataSource = function getSystemDataSource(contextRoot, noProgress) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/system-monitor/data-source/healthChecks"), null, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 資料處理系統服務監控

export var getSystemDataProcessing = function getSystemDataProcessing(contextRoot, noProgress) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/system-monitor/data-processing/healthChecks"), null, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 交通模型訓練系統服務監控

export var getSystemTrafficModelTrainer = function getSystemTrafficModelTrainer(contextRoot, noProgress) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/system-monitor/traffic-model-trainer/healthChecks"), null, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 交通模型預測系統服務監控

export var getSystemTrafficModelPrediction = function getSystemTrafficModelPrediction(contextRoot, noProgress) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/system-monitor/traffic-model-prediction/healthChecks"), null, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // Portal系統服務監控

export var getSystemMonitorPortalHealthChecks = function getSystemMonitorPortalHealthChecks(contextRoot, noProgress) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/system-monitor/portal/healthChecks"), null, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // App系統服務監控

export var getSystemMonitorAppHealthChecks = function getSystemMonitorAppHealthChecks(contextRoot, noProgress) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/system-monitor/app/healthChecks"), null, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // Web Site系統服務監控

export var getSystemMonitorWebSiteHealthChecks = function getSystemMonitorWebSiteHealthChecks(contextRoot, noProgress) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/system-monitor/web-site/healthChecks"), null, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 資料供應

export var getSystemOpenAPIHealth = function getSystemOpenAPIHealth(contextRoot, noProgress) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/system-monitor/open-api/healthChecks"), null, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};